<template>
<!--  <div class="d-grid gap-2 col-md-6 col-xl-8 mx-auto">-->
  <div class="d-grid gap-2">
      <a class="btn btn-primary btn-block" :href=loginUrl>
          <img class="google-icon" :src="`${$imagePathBase}logos/google-logo.svg`"/>
          <span v-if="createAccount" class="google-text">Sign Up with Google</span>
          <span v-else class="google-text">Sign In with Google</span>
      </a>
  </div>
</template>


<script>
import { defineComponent } from 'vue'
import {userStore} from "@/userStore";

export default defineComponent({
  // eslint-disable-next-line
  name: "Google", // should have a multi-word name
  props: ['createAccount'],
  emits: ['user-updated'],
  computed: {
    user() {
      return userStore.user;
    },

    loginUrl() {
      const urlObject = new URL(`${window.location.origin}/api/auth/login/google`);
      for (const key in this.$route.query) {
        //if (this.$route.query.hasOwnProperty(key)) {
        if (Object.hasOwn(this.$route.query, key)) {
          urlObject.searchParams.append(key, this.$route.query[key]);
        }
      }
      return urlObject.toString();
    }
  },

  data() {
    return {
    }
  },
  mounted() {
    //console.log('google query params', this.$route.query);
  },
  methods: {
  }
});
</script>


<style scoped>
.row {
  margin-top: 50px;
}

.google-icon {
  padding-right: 10px;
  height: 20px;
  margin-top: -2px;
}
</style>